class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.detailDisclosures = document.querySelectorAll('[data-dropdown-menus]');
    this.menuLinksOnly = document.querySelectorAll('[data-link-only]');

    this.addEventListener('keyup', onKeyUpEscape);
    if (this.dataset.closeWithClick === '1') {
      document.addEventListener('click', this.onClick.bind(this));
    } else {
      this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    }
  }

  connectedCallback() {
    this.mainDetailsToggle.addEventListener('mouseenter', () => {
      const flyout_menu = this.mainDetailsToggle.querySelector('flyout-menu');
      const submenu = this.mainDetailsToggle.querySelector('[data-submenu]');
      const closeMenuAfterMouseLeave = ((menu) => {
        menu.addEventListener('mouseleave', () => {
          this.mainDetailsToggle.removeAttribute('open');
        }, { once: true });
      });

      this.detailDisclosures.forEach((detail) => {
        if (detail !== this.mainDetailsToggle) {
          detail.removeAttribute('open');
        }
      });

      this.mainDetailsToggle.setAttribute('open', true);

      if (flyout_menu) closeMenuAfterMouseLeave(flyout_menu);
      if (submenu) closeMenuAfterMouseLeave(submenu);
    });

    this.menuLinksOnly.forEach((link) => {
      link.addEventListener('mouseenter', () => {
        this.detailDisclosures.forEach((detail) => {
          detail.removeAttribute('open');
        });
      })
    })
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  onClick(e) {
    if (!this.contains(e.target)) {
      this.close()
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open')
  }
}

customElements.define('details-disclosure', DetailsDisclosure);
